import { dateFunc } from "@/components/Functions/dateFunc";
import {
  customComparator,
  customDateComparator,
  formatAmountUnitDecimalPlace,
  havingEditPermission,
} from "@/utility/common";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const useDefaultUnitDetails = () => {
  const { defaultUnit } = useSelector((state: any) => state.case);
  const decimalPlace = defaultUnit?.decimalPlace;
  const defaultUnitName = defaultUnit?.name;
  return { decimalPlace, defaultUnitName };
};

// const useCaseDetails = () => {
//   const caseData = useCase();
//   const defaultUnit = caseData?.defaultUnit;
//   return { defaultUnit };
// };

// const CustomHeader = (props: any) => {
//   const { defaultUnit } = useCaseDetails();
//   const unitName = defaultUnit?.name;
//   const { params } = props;
//   if (props) return params + ` (${unitName})`;
// };

const AmountCellRenderer = ({ amount }: { amount: number }) => {
  const { decimalPlace, defaultUnitName } = useDefaultUnitDetails();
  if (amount === undefined || amount === null || isNaN(amount)) {
    return <span>-</span>;
  }
  return (
    <span>{`${formatAmountUnitDecimalPlace(
      Number(amount),
      decimalPlace
    )} ${defaultUnitName}`}</span>
  );
};
type documentConst = {
  data: {
    documentType: string;
    comment: string;
    createdBy: string;
    createdOn: string;
  };
};

//Column Defination for document table in claim summary
export const useColumnDefs = (abbreviation: string) => {
  const { t } = useTranslation();
  return [
    {
      minWidth: 50,
      flex: 1,
      field: "downloadAction",
      headerName: "",
      cellRenderer: "downloadActionRenderer",
      cellStyle: { justifyContent: "center" },
    },
    {
      cellRenderer: "nameCellRenderer",
      field: "displayName",
      headerName: t(
        "pages.claims.claimsDoumentsTab.tableColumnsDetails.column1"
      ),
      flex: 1,
      minWidth: 180,
      unSortIcon: true,
      autoHeight: true,
      cellClass: "grid-text-multiline",
      cellStyle: {
        "white-space": "normal",
        "line-height": "2",
        "word-break": "break-word",
      },
    },
    {
      cellRenderer: "typeCellRenderer",
      field: "documentType",
      headerName: t(
        "pages.claims.claimsDoumentsTab.tableColumnsDetails.column2"
      ),
      flex: 1,
      minWidth: 180,

      unSortIcon: true,
    },
    {
      field: "comment",
      headerName: t(
        "pages.claims.claimsDoumentsTab.tableColumnsDetails.column3"
      ),
      flex: 1,
      minWidth: 180,

      unSortIcon: true,
      autoHeight: true,
      cellClass: "grid-text-multiline",
      cellStyle: {
        "white-space": "normal",
        "line-height": "2",
        "word-break": "break-word",
      },
    },
    {
      field: "createdBy",
      headerName: t(
        "pages.claims.claimsDoumentsTab.tableColumnsDetails.column4"
      ),
      flex: 1,
      minWidth: 180,
      unSortIcon: true,

      sortable: true,
    },
    {
      field: "createdOn",
      headerName: t(
        "pages.claims.claimsDoumentsTab.tableColumnsDetails.column5"
      ),
      flex: 1,
      minWidth: 190,
      unSortIcon: true,
      sort: "desc",
      sortable: true,
      cellRenderer: function (params: documentConst) {
        return (
          dateFunc(params.data.createdOn).formattedDateTime + " " + abbreviation
        );
      },
    },
    {
      field: "action",
      headerName: "",
      flex: 1,
      minWidth: 180,

      sortable: false,
      cellRenderer: "actionRenderer",
      cellStyle: { justifyContent: "right" },
    },
  ];
};

type taskConst = {
  data: {
    name: string;
    dueDate: string;
    status: string;
    type: string;
    createdOn: string;
    createdBy: string;
    updatedOn: string;
  };
};

// function convertDateTimeinDate(getDate: any) {
//   const date = new Date(getDate);

//   const day = date.getDate().toString().padStart(2, '0');
//   const month = (date.getMonth() + 1).toString().padStart(2, '0'); // getMonth() is zero-indexed
//   const year = date.getFullYear();

//   const formattedDate = `${day}-${month}-${year}`;

//   return formattedDate; // Outputs: 2024-10-08
// }

// Column Defination for tasks table in claim summary
export const useColumnTaskDefs = (abbreviation: string) => {
  const { t } = useTranslation();
  return [
    {
      cellRenderer: "taskCellRenderer",
      field: "name",
      autoHeight: true,
      wrapText: true,
      headerName: t("pages.claims.taskTab.tableColumnsDetails.column1"),
      comparator: customComparator,
      flex: 1,
      minWidth: 135,
      unSortIcon: true,
      cellClass: "text-bold-underline grid-text-multiline",
      cellStyle: {
        "white-space": "normal",
        "line-height": "2",
        "word-break": "break-word",
      },
    },
    {
      field: "dueDate",
      headerName: t("pages.claims.taskTab.tableColumnsDetails.column2"),
      flex: 1,
      minWidth: 135,

      unSortIcon: true,
      cellRenderer: function (params: taskConst) {
        return dateFunc(params.data.dueDate).formattedDateOnly;
      },
    },
    {
      field: "status",
      headerName: t("pages.claims.taskTab.tableColumnsDetails.column3"),
      flex: 1,
      minWidth: 135,
      unSortIcon: true,

      sortable: true,
      cellRenderer: "statusRenderer",
    },
    {
      field: "type",
      headerName: t("pages.claims.taskTab.tableColumnsDetails.column4"),
      flex: 1,
      minWidth: 135,

      unSortIcon: true,

      sortable: true,
      cellRenderer: "typeRenderer",
    },
    {
      field: "createdOn",
      headerName: t("pages.claims.taskTab.tableColumnsDetails.column5"),
      flex: 1,
      minWidth: 135,
      comparator: customDateComparator,
      unSortIcon: true,
      sortable: true,
      sort: "desc",
      cellRenderer: function (params: taskConst) {
        return (
          dateFunc(params.data.createdOn).formattedDateTime + " " + abbreviation
        );
      },
    },
    {
      field: "createdBy",
      headerName: t("pages.claims.taskTab.tableColumnsDetails.column6"),
      flex: 1,
      minWidth: 155,

      unSortIcon: true,

      sortable: true,
    },
    {
      field: "updatedBy",
      headerName: t("pages.claims.taskTab.tableColumnsDetails.column7"),
      flex: 1,
      minWidth: 155,

      unSortIcon: true,

      sortable: true,
    },
    {
      field: "updatedOn",
      headerName: t("pages.claims.taskTab.tableColumnsDetails.column8"),
      flex: 1,
      minWidth: 155,

      unSortIcon: true,
      autoHeight: true,
      wrapText: true,
      sortable: true,
      cellStyle: {
        whiteSpace: "normal",
        lineHeight: "1.5",
      },
      cellRenderer: function (params: taskConst) {
        return (
          dateFunc(params.data.updatedOn).formattedDateTime + " " + abbreviation
        );
      },
    },
    {
      field: "action",
      headerName: "",
      flex: 1,
      minWidth: 60,

      sortable: false,
      cellRenderer: "actionRenderer",
      cellStyle: { justifyContent: "right" },
    },
  ];
};

export const useColumnCalimItemsDefs = (caseDataDetails: any) => {
  const { t } = useTranslation();
  const useCaseDetails = () => {
    const caseData = caseDataDetails;
    const defaultUnit = caseData?.defaultUnit;
    return { defaultUnit };
  };

  const CustomHeader1 = () => {
    const { defaultUnit } = useCaseDetails();
    const unitName = defaultUnit?.name;
    return `(${unitName})`;
  };
  return [
    {
      cellRenderer: "claimItemReference",
      field: "claimItemReference",
      headerName: t("pages.claims.claimIteamsTab.tablecolumns.column1"),
      flex: 1,
      minWidth: 180,
      sort: "desc",
      cellStyle: {
        whiteSpace: "normal",
        lineHeight: "1.5",
      },
      autoHeight: true,
      unSortIcon: true,
    },
    {
      cellRenderer: (param: any) => {
        if (param.node.rowPinned) return false;
        return <>{param?.data?.className || "-"}</>;
      },
      field: "className",
      headerName: t("pages.claims.claimIteamsTab.tablecolumns.column8"),
      flex: 1,
      minWidth: 180,
      unSortIcon: true,
      cellStyle: {
        whiteSpace: "normal",
        lineHeight: "1.5",
      },
      autoHeight: true,
    },
    {
      cellRenderer: "categoryName",
      field: "categoryName",
      headerName: t("pages.claims.claimIteamsTab.tablecolumns.column2"),
      flex: 1,
      minWidth: 180,
      unSortIcon: true,
      cellStyle: {
        whiteSpace: "normal",
        lineHeight: "1.5",
      },
      autoHeight: true,
    },
    {
      field: "originalAmt",
      headerName: t("pages.claims.claimIteamsTab.tablecolumns.column3", {
        unitName: CustomHeader1(),
      }),
      flex: 1,
      unSortIcon: true,

      cellRenderer: (param: {
        data: { originalAmt: number };
        node: {
          rowPinned: boolean;
          data: {
            columnField3: React.ReactElement<{ children: React.ReactNode }>;
          };
        };
      }) => {
        if (param.node.rowPinned) {
          return param.node.data.columnField3.props.children !== null ? (
            <AmountCellRenderer
              amount={Number(param.node.data.columnField3.props.children)}
            />
          ) : (
            "-"
          );
        } else {
          return param?.data?.originalAmt !== null ? (
            <AmountCellRenderer amount={Number(param.data.originalAmt)} />
          ) : (
            "-"
          );
        }
      },
      cellStyle: {
        whiteSpace: "normal",
        lineHeight: "1.5",
      },
      autoHeight: true,
      headerComponentParams: { params: "Original" },
      headerHeight: 150,
      minWidth: 180,

      cellClass: "align-right",
      headerClass: "stepHeaderClass",
    },
    {
      field: "currentAmt",
      headerName: t("pages.claims.claimIteamsTab.tablecolumns.column4", {
        unitName: CustomHeader1(),
      }),
      flex: 1,
      minWidth: 180,
      unSortIcon: true,

      cellRenderer: (param: {
        data: { currentAmt: number };
        node: {
          rowPinned: boolean;
          data: {
            columnField4: React.ReactElement<{ children: React.ReactNode }>;
          };
        };
      }) => {
        if (param.node.rowPinned) {
          return param.node.data.columnField4.props.children !== null ? (
            <AmountCellRenderer
              amount={Number(param.node.data.columnField4.props.children)}
            />
          ) : (
            "-"
          );
        } else {
          return <AmountCellRenderer amount={Number(param.data.currentAmt)} />;
        }
      },
      cellStyle: {
        whiteSpace: "normal",
        lineHeight: "1.5",
      },
      autoHeight: true,
      headerComponentParams: { params: "Current" },
      headerHeight: 150,
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
    },
    {
      field: "latestCreditorPositionAmt",
      headerName: t("pages.claims.claimIteamsTab.tablecolumns.column5", {
        unitName: CustomHeader1(),
      }),
      flex: 1,
      minWidth: 180,
      unSortIcon: true,

      autoHeight: true,
      headerComponentParams: { params: "Latest Creditor Position" },
      headerHeight: 150,
      cellRenderer: (param: {
        data: {
          latestCreditorPositionAmt: number;
          resolvedAmt: number;
          isResolved: boolean;
        };
        node: {
          rowPinned: boolean;
          data: {
            columnField5: React.ReactElement<{ children: React.ReactNode }>;
          };
        };
      }) => {
        if (param.node.rowPinned) {
          return param.node.data.columnField5.props.children !== null ? (
            <AmountCellRenderer
              amount={Number(param.node.data.columnField5.props.children)}
            />
          ) : (
            "-"
          );
        } else {
          return (
            <div>
              {param.data?.isResolved ? (
                "-"
              ) : param.data?.latestCreditorPositionAmt === null ? (
                "-"
              ) : (
                <AmountCellRenderer
                  amount={Number(param.data.latestCreditorPositionAmt)}
                />
              )}
            </div>
          );
        }
      },
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
    },
    {
      field: "latestDebtorPositionAmt",
      headerName: t("pages.claims.claimIteamsTab.tablecolumns.column6", {
        unitName: CustomHeader1(),
      }),
      flex: 1,
      minWidth: 180,
      unSortIcon: true,

      cellRenderer: (param: {
        data: {
          latestDebtorPositionAmt: number;
          resolvedAmt: number;
          isResolved: boolean;
        };
        node: {
          rowPinned: boolean;
          data: {
            columnField6: React.ReactElement<{ children: React.ReactNode }>;
          };
        };
      }) => {
        if (param.node.rowPinned) {
          return param.node.data.columnField6.props.children !== null ? (
            <AmountCellRenderer
              amount={Number(param.node.data.columnField6.props.children)}
            />
          ) : (
            "-"
          );
        } else {
          return (
            <div>
              {param.data?.isResolved ? (
                "-"
              ) : param.data?.latestDebtorPositionAmt === null ? (
                "-"
              ) : (
                <AmountCellRenderer
                  amount={Number(param.data.latestDebtorPositionAmt)}
                />
              )}
            </div>
          );
        }
      },
      headerComponentParams: { params: "Latest Debtor Position" },
      headerHeight: 150,
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
    },
    {
      field: "resolvedAmt",
      headerName: t("pages.claims.claimIteamsTab.tablecolumns.column7", {
        unitName: CustomHeader1(),
      }),
      flex: 1,
      minWidth: 180,
      unSortIcon: true,

      cellRenderer: (param: {
        data: { resolvedAmt: number; isResolved: boolean };
        node: {
          rowPinned: boolean;
          data: {
            columnField7: React.ReactElement<{ children: React.ReactNode }>;
          };
        };
      }) => {
        if (param.node.rowPinned) {
          return param.node.data.columnField7.props.children !== null ? (
            <AmountCellRenderer
              amount={Number(param.node.data.columnField7.props.children)}
            />
          ) : (
            "-"
          );
        } else {
          return (
            <div>
              {param.data.resolvedAmt !== null && param.data?.isResolved ? (
                <AmountCellRenderer amount={Number(param.data.resolvedAmt)} />
              ) : (
                "-"
              )}
            </div>
          );
        }
      },
      autoHeight: true,
      headerComponentParams: { params: "Resolved" },
      headerHeight: 150,
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
    },
    {
      field: "action",
      headerName: "",
      flex: 1,
      minWidth: 60,

      cellRenderer: "actionRenderer",
      cellStyle: { justifyContent: "right" },
    },
  ];
};

type commentConst = {
  data: {
    commentMsg: string;
    createdOn: string;
    createdBy: string;
  };
};

export const useColumnCommentHistoryDefs = (
  timeZone: string,
  editFun?: any,
  userPermission?: any
) => {
  const { t } = useTranslation();
  return [
    {
      cellRenderer: (params: any) => (
        <div
          className="text-bold-underline"
          style={
            havingEditPermission(userPermission) ? { cursor: "pointer" } : {}
          }
          onClick={() =>
            editFun &&
            havingEditPermission(userPermission) &&
            editFun(params.data)
          }
        >
          {params?.data?.commentMsg || ""}
        </div>
      ),
      field: "commentMsg",
      headerName: t("commonComponent.comment.tableCoumnsDetails.comment"),
      flex: 1,
      unSortIcon: true,
      autoHeight: true,
      cellClass: "grid-text-multiline",
      cellStyle: {
        "white-space": "normal",
        "line-height": "2",
        "word-break": "break-word",
      },
      minWidth: 150,
    },
    {
      field: "commentCreatedOn",
      headerName: t("commonComponent.comment.tableCoumnsDetails.postedOn"),
      flex: 1,
      unSortIcon: true,
      sort: "desc",
      cellRendererParams: {
        timeZoneName: timeZone,
      },
      cellRenderer: function (params: commentConst) {
        return (
          dateFunc(params.data.createdOn).formattedDateTime + " " + timeZone
        );
      },
      minWidth: 150,
    },
    {
      field: "createdBy",
      headerName: t("commonComponent.comment.tableCoumnsDetails.postedBy"),
      flex: 1,
      unSortIcon: true,
      minWidth: 150,
    },
    {
      field: "action",
      headerName: "",
      flex: 1,
      sortable: false,
      cellRenderer: "actionRenderer",
      cellStyle: { justifyContent: "right" },
      minWidth: 70,
    },
  ];
};
